import React, {useEffect, useState} from 'react';
import './NewLogin.scss';
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import Loader from "../../Loader";
import IconViewer from "../../../Assets/svg/IconViewer";
import StepLogin from "./FormStep/StepLogin";
import OnLoginHandler from "./OnLoginHandler";
import LoginBackground from "./LoginBackground";
import axios from "axios";
import StepForgetPass from "./FormStep/StepForgetPass";
import StepVerify from "./FormStep/StepVerify";
import StepNewPassword from "./FormStep/StepNewPassword";

const NewLogin = ({isAuthenticated}) => {

  const [isAuth, setIsAuth] = isAuthenticated;
  const [isAutoLogin, setIsAutoLogin] = useState(localStorage.getItem("token") !== null);
  const [formStep, setFormStep] = useState("LOGIN")
  const [initialData, setInitialData] = useState({
    list: [],
    type: "",
    color: "",
    icon: ""
  });
  const [isLoad, setIsLoad] = useState(false);
  const [sendData, setSendData] = useState({
    user: "",
    pass: "",
    captchaInput: "",
    mobileNumber: "",
    code: "",
    password: "",
    repeatPass: "",
    type: "recovery"
  })
  const [textCaptcha, setTextCaptcha] = useState("")

  useEffect(() => {
    if (!isAutoLogin) {
      const url = `${prefixUrl()}/check_user/?list`;
      _axios.get(url).then((response) => {
        if (response.data.status) {
          setInitialData(response?.data)
          setIsLoad(true)
        }
      });
    } else {
      axios({
        method: "POST",
        url: `${prefixUrl()}/check_user/`,
        params: {token: ""},
        headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
      }).then((response) => {
        for (const key in response.data) {
          localStorage.setItem(key, response.data[key]);
        }
        setIsAuth(true);
      })
    }
  }, []);

  const onLoginHandler = () => {
    void OnLoginHandler(sendData, formStep, textCaptcha, setIsAuth, setFormStep, setSendData)
  }

  const formStepHandler = () => {
    if (formStep === "LOGIN") {
      setFormStep("FORGET")
      setSendData({...sendData, captchaInput: ""})
    } else if (formStep === "FORGET") {
      setFormStep("LOGIN")
      setSendData({...sendData, captchaInput: ""})
    }
  }

  return (
    <>
      {isLoad ?
        <section className={`main-new-login login-type-${initialData?.type}`}>
          <div className={"fix-login-box"}>
            <div className={"bix-in-box"}>
              <div className={"logo-side"}>
                {initialData?.icon && <IconViewer icon={initialData?.icon}/>}
              </div>
              <div className={"content-side"}>
                {formStep === "LOGIN" ? <StepLogin sendData={sendData}
                                                   setSendData={setSendData}
                                                   textCaptcha={textCaptcha}
                                                   setTextCaptcha={setTextCaptcha}/> :
                  formStep === "FORGET" ? <StepForgetPass sendData={sendData}
                                                          setSendData={setSendData}
                                                          textCaptcha={textCaptcha}
                                                          setTextCaptcha={setTextCaptcha}/> :
                    formStep === "VERIFY" ? <StepVerify sendData={sendData}
                                                        setSendData={setSendData}/> :
                      formStep === "NEW_PASSWORD" ? <StepNewPassword sendData={sendData}
                                                                     setSendData={setSendData}/> : <></>}

                <button style={{color: initialData?.color}} className={"forget-pass-but"} onClick={formStepHandler}>
                  {formStep === "LOGIN" && "رمز عبور خود را فراموش کرده اید؟"}
                  {formStep === "FORGET" && "بازگشت"}
                </button>

              </div>
              <div className={"button-side"}>
                <button style={{background: initialData?.color}} onClick={onLoginHandler}>
                  {formStep === "LOGIN" && "ورود"}
                  {formStep === "FORGET" && "ارسال کد تایید"}
                  {formStep === "VERIFY" && "تایید"}
                  {formStep === "NEW_PASSWORD" && "تایید"}
                </button>
              </div>
            </div>
          </div>
          <LoginBackground initialData={initialData}/>
        </section> : <Loader/>}
    </>
  );
};

export default NewLogin;